export default {"src":"/_next/static/media/wav-svgrepo-com.ac7776cd.svg","height":303,"width":303,"blurWidth":0,"blurHeight":0};